import React from 'react'
import JobDetails1 from '../../../features/employers/components/JobDetails1'
import Menu_Lg_Bar from '../../../features/employerDashboard/components/menu_lg_bar'
import { DummyAfterLogin } from '../../CommonPublicPages/Navbars/components/DummyAfterLogin'
import { Outlet } from 'react-router-dom'

function JobDetailsPage1() {
  return (
    <div>

      {/* <DummyAfterLogin /> */}
      {/* <Menu_Lg_Bar /> */}
      <Outlet />
    </div>
  )
}

export default JobDetailsPage1
